import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import config from '@/config';

Vue.use(Vuex);

export const SET_ANSWER = 'SET_ANSWER';
export const SET_ATTACHMENT = 'SET_ATTACHMENT';
export const SET_SCORE = 'SET_SCORE';

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: config.appId,
  })],

  state: {
    answer: null,
    attachment: null,
    score: null,
  },

  mutations: {
    [SET_ANSWER](state, { answer = null }) {
      state.answer = answer;
    },

    [SET_ATTACHMENT](state, { attachment = null }) {
      state.attachment = attachment;
    },

    [SET_SCORE](state, { score = null }) {
      state.score = score;
    },
  },

  actions: {},
});
